// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { locationSearchFormStyles } from "@cahaba/Overrides/Components/LocationSearchForm";
import { css } from "styled-components";

locationSearchFormStyles.searchResultRowNumberGridItem = {
    width: 1,
    css: css`
        justify-content: center;
    `,
};

locationSearchFormStyles.locationRowNumberText = {
    color: "primary",
    weight: "bold",
};

locationSearchFormStyles.searchResultLocationIconGridItem = {
    width: 2,
};

locationSearchFormStyles.searchResultAddressInfoGridItem = {
    width: 12,
};

locationSearchFormStyles.searchResultPhoneGridItem = {
    width: [6, 6, 4, 4, 3],
};
locationSearchFormStyles.searchResultContentGridItem = {
    width: [6, 6, 4, 4, 3],
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [6, 6, 4, 4, 3],
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: [6, 6, 4, 4, 3],
};

locationSearchFormStyles.searchResultLocationGridContainer = {
    gap: 30,
};

locationSearchFormStyles.searchResultLocationLeftGridItem = {
    width: 9,
};

locationSearchFormStyles.searchResultLocationRightGridItem = {
    width: 3,
};

locationSearchFormStyles.searchResultDealerNameGridItem = {
    width: 12,
};

locationSearchFormStyles.searchResultPreferredResellerTextGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

locationSearchFormStyles.searchResultPreferredResellerIconGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

locationSearchFormStyles.searchResultPreferredResellerGridContainer = {
    gap: 10,
};

locationSearchFormStyles.searchResultPreferredResellerText = {
    size: ".8em",
    css: css`
        text-align: center;
        word-break: keep-all;
    `,
};
